let readPages, skipRestPrice, readingTimeLeft, readingTimeCurrent, tcCountdown, tcComplete;
readPages = 0;
tcComplete = false;
const totalPages = TCParagraphs.length;
const skipCurrentPrice = 0;
skipRestPrice = 7;
readingTimeCurrent = TCParagraphs[0].mins;
readingTimeLeft = 0;
for (const tcp of TCParagraphs)
{
    readingTimeLeft += tcp.mins;
}

function init_tc_timer(init) {
    if(init && !tcComplete) {
        tcCountdown = setTimeout(function(){
            display_tc(true);
        }, 5000);
    } else {
        clearTimeout(tcCountdown);
    }
}

function display_tc(show) {
    $("html, body").animate({ scrollTop: 0 }, "slow");
    const tc = $('#t-and-c');
    show ? tc.fadeIn() : tc.fadeOut();
    tcComplete = true;
}

/**
 * disable/enable 'continue' or 'Add To Monthly Plan' btns
 * @param {boolean} disable - disable or enable
 * @param {boolean} continueBtn - target continue btn or 'add to monthly plan' btn (when false);
 */
function disableTCBtn(disable)
{
    const target = $('#progress-panel__btn--continue');

    disable ?
        target.addClass('progress-panel__btn-wrapper--btn-disabled')
        :
        target.removeClass('progress-panel__btn-wrapper--btn-disabled');
}

function continueToNextPage()
{
    removeWarning();
    readPages += 1;
    (readPages >= totalPages) ? display_tc(false) : updateTCContent();
}

function updateTCContent(initialRun)
{
    const TCP = TCParagraphs[readPages];
    const TCPprevious = initialRun ? false : TCParagraphs[readPages - 1]

    $(`#consent-checkbox`).prop('checked', !!initialRun);
    initialRun ? disableTCBtn(false) : disableTCBtn(true);
    if (!initialRun) {
        $('#tc-sheet__consent--container, #tc-sheet-reading-time').show();
        $('#tc-skip__img').hide();
    }
    skipRestPrice -= initialRun ? 0 : skipCurrentPrice;
    readingTimeCurrent = TCP.mins;
    readingTimeLeft -= initialRun ? 0 : TCPprevious.mins;


    $('.js-tc-total').html(totalPages);
    $('.js-tc-counter').html(readPages);
    $('.js-tc-mins').html(readingTimeLeft);


    let skipRestPriceCountUp = new CountUp('skip-rest-price', skipRestPrice, {startVal: skipRestPrice + skipCurrentPrice});
    skipRestPriceCountUp.start();
    $('[data-addtocheckout="skipAllTandC"]').addClass('animatecss-pulse');
    setTimeout(function ()
    {
        $('[data-addtocheckout="skipAllTandC"]').removeClass('animatecss-pulse');
    }, 510);


    $('#t-and-c__tc-sheet').scrollTop(0);
    $('#tc-sheet-reading-time').html(readingTimeCurrent);
    $('#tc-sheet__title').html(TCP.title);
    $('#tc-sheet__content').html(TCP.content);
}

function isDisabled(self)
{
    if (self.hasClass('progress-panel__btn-wrapper--btn-disabled'))
    {
        self.parents('.t-and-c__card').addClass('t-and-c__card--with-warning');
        $('#consent-checkbox-svg').addClass('tada');
        setTimeout(function ()
        {
            $('#consent-checkbox-svg').removeClass('tada');
        }, 1000);

        return true;
    }
    else
    {
        return false;
    }
}

function removeWarning()
{
    $('.t-and-c__card').removeClass('t-and-c__card--with-warning');
}

function fillCookiePolicyModal()
{
    for (const tc of TCParagraphs)
    {
        const target = $('#cookie-modal__body');
        const h2 = document.createElement('H2');
        h2.innerHTML = tc.title;
        target.append(h2);
        target.append(tc.content);
    }
}

// ************************************</editor-fold>
// EVENTS
// ************************************<editor-fold>
updateTCContent(true);
fillCookiePolicyModal();

$('#progress-panel__btn--continue').click(function ()
{
    const self = $(this);
    if (!isDisabled(self))
    {
        continueToNextPage(false);
    }
});


$('#consent-checkbox').change(function ()
{
    removeWarning();
    $(this).is(':checked') ?
        disableTCBtn(false)
        :
        disableTCBtn(true);
});









